import { Component } from '@angular/core';
import { AuthService } from '@shared/services/auth.service';

@Component({
  templateUrl: './user-locked.component.html',
  styleUrls: ['./user-locked.component.less']
})
export class UserLockedComponent {
  public constructor(private authService: AuthService) {}

  public async retryAction() {
    await this.authService.logout();
  }
}
